import React, { useState, useEffect } from 'react';
import { Select, MenuItem, FormControl } from '@mui/material';
import { api } from '../../utils/api';
import { useAccount } from '../../contexts/AccountContext';

export default function AccountSwitcher() {
    const [accounts, setAccounts] = useState([]);
    const { userData, setUserData, currentAccountId } = useAccount();
    
    useEffect(() => {
        const fetchAccounts = async () => {
            if (userData?.email) {
                try {
                    const accountsData = await api.get(`/api/users/accounts/${userData.email}`);
                    setAccounts(accountsData);
                } catch (error) {
                    console.error('Error fetching accounts:', error);
                }
            }
        };
        
        fetchAccounts();
    }, [userData?.email]);



    const handleAccountChange = async (event) => {
        const selectedAccount = accounts.find(acc => acc.id === event.target.value);
        if (selectedAccount) {
            try {
                const response = await api.get(`/api/metrics/bar/${selectedAccount.id}`);
                
                setUserData({
                    ...userData,
                    accountId: selectedAccount.id,
                    barName: selectedAccount.barName,
                    barInfo: {
                        ...response,
                        includeMembershipQuestion: selectedAccount.includeMembershipQuestion
                    }
                });

                
            } catch (error) {
                console.error('Error fetching bar info:', error);
            }
        }
    };

    if (accounts.length <= 0) {
        return null;
    }

    return (
        <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
                value={currentAccountId || ''}
                onChange={handleAccountChange}
                className="inter-custom"
                displayEmpty
                sx={{
                    backgroundColor: '#ffffff',  // white background like blast table
                    borderRadius: '12px',
                    '& .MuiSelect-select': {
                        py: 1,
                        color: '#2B0063',        // brand purple color
                        fontWeight: 600          // semi-bold text
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '12px',
                        borderColor: '#e5e7eb'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2B0063'
                    },
                    '& .MuiSvgIcon-root': {
                        color: '#2B0063'
                    },
                    boxShadow: '0 1px 3px rgba(0,0,0,0.12)'  // subtle shadow like blast table
                }}
            >
                {accounts.map(account => (
                    <MenuItem 
                        key={account.id} 
                        value={account.id}
                        sx={{
                            fontWeight: 600,     // semi-bold text for menu items
                            '&:hover': {
                                backgroundColor: '#f9f9f9'
                            },
                            '&.Mui-selected': {
                                backgroundColor: '#2B0063',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#2B0063'
                                }
                            }
                        }}
                    >
                        {account.barName || 'Unnamed Bar'}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
} 